import type { KapitelStatus } from '../types'

// Kapitel publiceras oavsett granskningsstatus (den här webben är ett test-/
// förhandsgranskningsverktyg, inte produktionssajten) — badgen gör det synligt
// att innehållet inte är färdigt granskat. Godkända kapitel (och kapitel utan
// känd status) visar ingen badge, av samma skäl som lärarhandledningens badge
// togs bort när LEDA:s innehåll blev klart: statusen ska synas medan något är
// på gång, inte påstå något om färdigt innehåll.
const ETIKETT: Record<string, string> = {
  disposition: 'Disposition',
  utkast: 'Utkast',
  under_granskning: 'Under granskning',
  reviderad: 'Reviderad',
}

export default function KapitelStatusBadge({ status }: { status: KapitelStatus }) {
  if (!status || status === 'godkand') return null
  return <span className="chip chip-status">{ETIKETT[status] ?? status}</span>
}
